import React, { useEffect, useState } from 'react';
import InputMask from 'react-input-mask';
import Field from './Field';
import { validatePersonalNumber } from './validatePersonalNumber';
export const PersonalIdentificationField = (props) => {
    const [personalNumber, setPersonalNumber] = useState('');
    const [validPersonalNumber, setValidPersonalNumber] = useState(false);
    const onChange = props.onChange;
    useEffect(() => {
        if (props.value !== undefined) {
            setPersonalNumber(props.value);
        }
    }, [props.value]);
    useEffect(() => {
        const valid = validatePersonalNumber(personalNumber);
        if (valid) {
            onChange(personalNumber);
        }
        else {
            onChange(undefined);
        }
        setValidPersonalNumber(valid);
    }, [personalNumber, onChange]);
    const handleInputChange = (event) => {
        setPersonalNumber(event.target.value);
    };
    const digit = /[0-9]/;
    const mask = [digit, digit, digit, digit, digit, digit, digit, digit, '-', digit, digit, digit, digit];
    return (React.createElement(InputMask, { onChange: handleInputChange, alwaysShowMask: false, maskPlaceholder: "_", mask: mask, value: personalNumber },
        React.createElement(Field, { required: props.required, name: "personalNumber", autoComplete: "autoComplete", error: personalNumber.trim().length > 12 && !validPersonalNumber, helperText: "YYYYMMDD-XXXX", errorText: personalNumber.trim().length > 12 &&
                !validPersonalNumber &&
                'Fel format (YYYYMMDD-XXXX) eller ogilltigt', label: "Personnummer", placeholder: "Fyll i personnummer", sx: props.sx })));
};
export default PersonalIdentificationField;
